<template>
    <div class="notifyCover" :class="toggleClass"></div>
    <div class="notifyContainer" :class="toggleClass">
        <div class="position-relative w-100 h-100">
            <div class="storeIcon" :class="toggleClass_1">
                <img :src="storeIcon" alt="">
            </div>
            <div class="notifyBody" :class="toggleClass_2">
                <div class="coveron" :class="toggleClass_4"></div>
                <span v-show="auto" :id="progressId" :class="progressColor" class="timeLine"></span>
                <div class="iconType"><i :class="iconType"></i></div>
                <div class="col-12 messaged px-2" v-html="message"></div>
                <button v-if="toggle && !bolQuest" @click="closeNotify()" :class="btnColor" class="mb-3 buttoned btn-sel-1 btn fw-bold rounded px-3 py-0" type="button">{{buttonText}}</button>
                <button v-if="toggle && bolQuest" @click="closeNotify('cancel')" class="text-white buttoned btn-secondary mb-3 me-2 btn-sel-1 btn fw-bold rounded close" type="button"><i class="fa-solid fa-times px-4"></i></button>
                <button v-if="toggle && bolQuest" @click="closeNotify('continue')" :class="btnColor" class="mb-3 ms-2 btn-sel-1 buttoned btn fw-bold rounded px-4 py-0" type="button">{{buttonText}}</button>
                <div class="coveroff" :class="toggleClass_3"></div>

            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "notificationStore",
    emits:['closeNotify', 'filterEventNotify'],
    props:{
        type:{ //tipo de colores de este modal-notificacion entre otros
            default: "danger",
            type: String
        },
        storeIcon:{ //url icono de la tienda
            default: "",
            type: String
        },
        message:{ //mensaje enmedio de este componente
            default: "",
            type: String
        },
        buttonText:{ //texto en el boton para cerrar
            default: "Entendido",
            type: String
        },
        timeAuto:{ //tiempo antes de cerrar automaticamente
            default: 5,
            type: Number
        },
        active:{ //valor helper para abrir y cerrar este modal-notificacion
            default: false,
            type: Boolean
        },
        returned:{//valor que retornara al cerrar a su padre en un emit
            default:["", ""],
            type:Array
        },
        auto:{//si se desea autocerrar el modal despues de un tiempo
            default: true,
            type: Boolean
        },
        toggle:{//si se desea mostrar algun boton para cerrar o no
            default: true,
            type: Boolean
        },
        bolQuest:{ // si los botones deben hacer alucion a una pregunta, cancel no devuelve returned
            default: false,
            type: Boolean
        }
    },
    watch:{
        active(){
            if(this.active){
                this.setType()
                this.runNotify()
            }else{
                this.stopNotify()
            }
        }
    },
    methods:{
        setType(){
            /**
             *
             * determina los colores del modal por el prop type
             * @param /
             * @change /
             * @return /
             */
            switch(this.type){
                case "danger":
                    this.iconType = "fa-solid fa-circle-exclamation text-danger"
                    this.progressColor = "bg-danger"
                    this.btnColor = "btn-danger text-white"
                    break
                case "warning":
                    this.iconType = "fa-solid fa-triangle-exclamation text-warning"
                    this.progressColor = "bg-warning"
                    this.btnColor = "btn-warning text-black"
                    break
                case "success":
                    this.iconType = "fa-solid fa-circle-check text-success"
                    this.progressColor = "bg-success"
                    this.btnColor = "btn-sucess text-white"
                    break
                case "info":
                    this.iconType = "fa-solid fa-circle-info text-info"
                    this.progressColor = "bg-info"
                    this.btnColor = "btn-info text-black"
                    break
                case "primary":
                    this.iconType = "fa-solid fa-hexagon-exclamation text-primary"
                    this.progressColor = "bg-primary"
                    this.btnColor = "btn-primary text-white"
                    break
                default:
                    this.iconType = "fa-solid fa-hexagon-exclamation text-primary"
                    this.progressColor = "bg-primary"
                    this.btnColor = "btn-primary text-white"
                
            }
        },
        runNotify(){
            /**
             *
             * realiza la animacion del modal y ejecuta el conteo autocierre si es requerido
             * @param /
             * @change /
             * @return /
             */
            if(this.bolQuest){
                this.toggleClass = "runned";
                this.toggleClass_1 = "runned";
                this.toggleClass_2 = "runned";
                this.toggleClass_3 = "runned";
                this.toggleClass_4 = "runned";
            }else{
                this.toggleClass = "runned";
                this.toggleClass_1 = "reboteappend";
                this.toggleClass_2 = "inn";
                this.toggleClass_3 = "aparition";
                this.toggleClass_4 = "wait";
            }
            if(this.auto){
                this.timerClose()
            }
        },
        stopNotify(){
            /**
             *
             * wipe a las animaciones del modal
             * @param /
             * @change /
             * @return /
             */
            this.toggleClass = "stoped";
            this.toggleClass_1 = "stoped";
            this.toggleClass_2 = "stoped";
            this.toggleClass_3 = "stoped";
            this.toggleClass_4 = "stoped";
        },
        closeNotify(type){
            /**
             *
             * coerra el modal con o sin animacion, termina el tiempo auto y retorna el valor o no
             * @param type: determina el cierre del modal, animacion y valor retornado
             * @change /
             * @return /
             */
            switch (type){
                case "cancel":
                    this.$emit('closeNotify', this.returned[1] || false)
                    this.$emit('filterEventNotify', this.returned[1] || false)
                    break
                case "continue":
                    this.$emit('filterEventNotify', this.returned[0] || true)
                    this.$emit('closeNotify', this.returned[0] || true)
                    break
                default:
                    this.toggleClass_2 = "out";
                    this.sleep(500).then( (response) => {
                        clearInterval(this.interval);
                        this.$emit('closeNotify', this.returned[0] || true)
                    })
                    break
            }
        },
        timerClose(){
            /**
             *
             * ejecuta el conteo del tiempo y la animacion de la barra de conteo
             * @param /
             * @change /
             * @return /
             */
            this.bar = document.getElementById(this.progressId);
            this.bar.style.width = 0 + "%";
            this.intervalWidth = 0;
            let time = (this.timeAuto > 1 && this.timeAuto < 60) ? parseInt(this.timeAuto) * 10 : 60 ;
            this.sleep(700).then( (response) => { //tiempo que dura la animacion antes del conteo de cierre
                this.interval = setInterval(this.frame, time);
            })
        },
        frame(){
            /**
             *
             * cambia longitud de la barra de conteo superior
             * y cierra el modal si este llega a cierta longitud
             * @param /
             * @change /
             * @return /
             */
            if (this.intervalWidth >= 96) {
                    clearInterval(this.interval);
                    if(this.active){
                        this.closeNotify()
                    }
                } else {
                    this.intervalWidth++;
                    this.bar.style.width = this.intervalWidth + "%";
            }
        },
        sleep(time = 1800){
            /**
             *
             * hacer esperar para ejecutar algo con then
             * @param time: number, tiempo de espera
             * @change /
             * @return /
             */
			return new Promise((resolve) => {
				setTimeout(() => {
				resolve('finished');
				}, time);
			});
		},
    },
    data(){
        return{
            toggleClass:"stoped", //clases con animacion desactivada
            toggleClass_1:"stoped",
            toggleClass_2:"stoped",
            toggleClass_3:"stoped",
            toggleClass_4:"stoped",
            iconType:"", //tipo de icono fa por el prop type
            progressColor: "", //color de la barra por el prop type
            btnColor: "", //colo de boton por el prop type
            progressId: String(Date.now()), //valor unico para la barra de conteo por si se enciman varios modales
            interval:null, //intervalo para actualizar la barra
            intervalWidth:1, //medida porcentual de la barra
            bar:null //almacen para el objeto barra
        }
    }
}
</script>

<style scoped>
    @media (min-width: 0px) and (max-width: 991.98px) {
        .notifyContainer{
            width: 80% !important;
            left:10% !important;
        }
	}
    .notifyCover{
        width: 100%;
        height: 100%;
        background-color: rgba(4, 4, 4, 0.2);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 9999;
    }
    .notifyContainer{
        position: fixed;
        width: 40%;
        height: 300px;
        top:calc(50% - 200px);
        left:30%;
        z-index: 10000;
        color:var(--dodecagenary)
    }
    .notifyBody{
        position: absolute;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
        height: 100%;
        border-radius: .8em;
        z-index: 10;
        overflow: hidden;
    }
    .iconType{
        width: 100%;
        font-size: 55px;
        text-align:center;
        z-index: 10;
    }
    .message{
        color: #000 !important;
        font-weight: bold;
        display: flex;
        justify-content: center;
        text-align: center;
        padding: 10px;
        z-index: 10;
    }
    .coveroff{
        position: absolute;
        left:0;
        top:0;
        width: 100%;
        height: 100%;
        background-color: black;
        opacity: 0;
        pointer-events: none;
        z-index: 11;
    } 
    .coveron{
        position: absolute;
        left:0;
        top:0;
        width: 100%;
        height: 100%;
        background-color: #fff;
        box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
        filter: blur(2px);
        -webkit-filter: blur(2px);
        opacity: 1;
        pointer-events: none;
        z-index: 1;
    } 

    .messaged{
        z-index: 2;
    }

    .buttoned{
        z-index: 2;
        max-height: 80px;
    }
    .storeIcon{
        position: absolute;
        height: 200px;
        width: 200px;
        left:calc(50% - 100px);
        top:calc(50% - 100px);
        z-index: 9;
    }
    .storeIcon img{
        height: 100%;
        width: 100%;
    }
    .timeLine{
        width: 0%;
        height: 2px;
        position: absolute;
        top:1px;
        left:2%;
        z-index: 10;
    }
    .stoped{
        display: none;
    }
    .runned{
        
    }
    .rounded-btn{
        border-radius: 5px;
        z-index: 10;
    }
    .reboteappend {
        opacity: 0;
        animation:1s reboteappend 1;
    }
    .inn {
        animation:1.45s inn 1;
        transition: transform 1s linear;
    }
    .out {
        animation:0.7s out 1;
        transition: transform 0.8s linear;
    }
    .aparition {
        animation:0.7s aparition 1;
        transition: transform 1s linear;
    }
    .wait {
        animation:0.7s wait 1;
    }

    .close{
        position: absolute !important;
        right:0;
        z-index: 10;
        top:5px;
    }

    @keyframes reboteappend{
        0%{
            opacity: 0;
            transform: scale(0.3);
        }
        25%{
            opacity: 1;
            transform: scale(1.1);
        }
        40%{
            transform: scale(0.9);
        }
        60%{
            transform: scale(0.9);
        }
        75%{
            opacity: 1;
            transform: scale(1.1);
        }
        100%{
            opacity: 0;
            transform: scale(0);
        }

    }
    @keyframes inn{
        0%{ opacity: 0;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            left:calc(50% - 40px);
            top:calc(50% - 40px);
        }
        50%{
            opacity: 0;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            left:calc(50% - 40px);
            top:calc(50% - 40px);
        }
        51%{
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            transform-origin: 50% 50%;
            transform: scale(0.2);
            opacity: 1;
        }
        65%{
            border-radius: 0%;
            transform-origin: 50% -200%;
        }
        75%{
            transform: scale(0.9);
        } 
        78%{
            transform: scale(1);
            transform-origin: 50% 50%;
        } 
    }
    @keyframes aparition{
        0%{
            opacity: 1;
        }
        99%{
            opacity: 1;
        }
        100%{
            opacity: 0;
        }
    }
    @keyframes wait{
        0%{
            opacity: 0;
        }
        99%{
            opacity: 0;
        }
        100%{
            opacity: 1;
        }
    }
    @keyframes out{
        25%{
            transform: scale(0.9);
        }
        50%{
            opacity: 1;
            transform: scale(1.1);
        }
        100%{
            opacity: 0;
            transform: scale(0);
        }
    }

</style>